import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { Show } from '../models/show';
import { formatShowDate } from '../utils/show-date';
import { showTitle } from '../utils/show-title';

@Component({
  selector: 'app-next-show',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block w-full' },
  templateUrl: './next-show.component.html',
})
export class NextShowComponent {
  readonly show = input<Show | null>(null);
  readonly selected = output<Show>();
  readonly dateLabel = computed(() => {
    const show = this.show();
    return show ? formatShowDate(show.datetime) : ' ';
  });
  readonly title = computed(() => {
    const show = this.show();
    return show ? showTitle(show) : ' ';
  });

  select() {
    const show = this.show();
    if (show) this.selected.emit(show);
  }
}
